import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, NodeViewComponent } from '@xanadu/core';
import { Node, Club, Client, NodeModel } from '@xanadu/model';
import { ClientCache, ClubCache } from '@xanadu/cache';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'app-client-view',
    templateUrl: './client-view.component.html',
    styleUrls: ['./client-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('client-view')
export class ClientViewComponent extends NodeViewComponent<Client | Club> {
    private readonly clientCache = inject(ClientCache);
    private readonly clubCache = inject(ClubCache);

    protected get nodeType(): string | undefined {
        return 'client';
    }

    protected getPanel(model: NodeModel) {
        const node = model.node;

        if (node instanceof Club) {
            return {
                node: node,
                component: 'club-panel'
            };
        } else {
            return {
                node: node,
                component: 'client-panel'
            };
        }
    }

    protected delete(node: Node): Observable<Client | Club> {
        return this.dataService.delete<Client | Club>(node as any)
        .pipe(switchMap(result => {
            if (result instanceof Client) {
                this.clientCache.update();
            } else if (result instanceof Club) {
                this.clubCache.update();
            }

            return of(result);
        }));
    }
}
